import { FormattedNumber } from '../components/formatted-number.tsx';

export default function pointsTranslation(
  t: (key: string, options?: { count: number }) => string,
  count: number | null | undefined,
  concatenate = false
): string {
  const safeCount = count ?? 0;
  const translatedPoints =
    safeCount >= 1000000 ? t('point.name_other') : t('point.name', { count: safeCount });

  return concatenate
    ? `${FormattedNumber({ value: safeCount, style: 'decimal' })} ${translatedPoints}`
    : translatedPoints;
}
